import { create } from 'zustand';

/**
 * The chat conversation the user currently has open on screen.
 *
 * Set by the chat detail route while it's mounted, cleared on unmount. Read from
 * the global WS handler (`useRealtimeNotifications`) to suppress the toast + sound
 * for a message that belongs to the chat the user is already looking at.
 */
type ActiveChatSlice = {
  activeChatId: string | null;
  setActiveChatId: (chatId: string | null) => void;
};

export const useActiveChatStore = create<ActiveChatSlice>((set) => ({
  activeChatId: null,
  setActiveChatId: (chatId) => set({ activeChatId: chatId }),
}));
